/**
 * Created by efowler on 4/1/14.
 */
'use strict';

frontendApp.controller('NotificationCtrl', ['$scope', '$rootScope', 'InviteService', 'NavigationService', 'NotificationService', 'ProjectService', function($scope, $rootScope, InviteService, NavigationService, NotificationService, ProjectService) {
    NavigationService.setActiveTab('notifications');
    $rootScope.$broadcast('clearCurrentSelected');

    $scope.invites = InviteService.findAll();

    $scope.acceptInvite = function(invite) {
        InviteService.acceptInvite(invite, function() {
            NotificationService.addSuccess({
                title: 'Invite Accepted',
                description: "Welcome to " + invite.projectName,
                timeout: 5000
            });

            $scope.invites = InviteService.findAll();
            ProjectService.RefreshProjects();
        });
    };

    $scope.declineInvite = function(invite) {
        InviteService.delete(invite, function() {
            NotificationService.addSuccess({
                title: 'Invite Declined',
                timeout: 5000
            });

            $scope.invites = InviteService.findAll();
        });
    };

}]);
